import { useEffect, useState } from "react";
import { fetchServices } from "../api.js";
import ServiceCard from "../components/ServiceCard.jsx";

export default function Dashboard() {
  const [services, setServices] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchServices();
        if (!cancelled) setServices(data.services || []);
      } catch (e) {
        if (!cancelled) setError(String(e.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <p>Loading services…</p>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <h1>Services</h1>
      <div className="grid">
        {services.map((s) => (
          <ServiceCard key={s.serviceName} service={s} />
        ))}
      </div>
      {services.length === 0 && <p style={{ color: "#71767b" }}>No services yet.</p>}
    </>
  );
}
